import { render, staticRenderFns } from "./SendQuotePage.vue?vue&type=template&id=ce2fcbfe&scoped=true"
import script from "./SendQuotePage.vue?vue&type=script&lang=js"
export * from "./SendQuotePage.vue?vue&type=script&lang=js"
import style0 from "./SendQuotePage.vue?vue&type=style&index=0&id=ce2fcbfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2fcbfe",
  null
  
)

export default component.exports